import { Component, Inject, AfterViewInit, ViewEncapsulation } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
	selector: 'app-terms-policy-dialog',
	templateUrl: './terms-policy-dialog.component.html',
	styleUrls: ['./terms-policy-dialog.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class TermsPolicyDialogComponent implements AfterViewInit {

	endScroll: boolean;
	showacceptButton: boolean;
	public typeDoc = "terms";
	constructor(
		public dialogo: MatDialogRef<TermsPolicyDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		if (data) {
			this.showacceptButton = data.acceptButton;
			this.typeDoc = data.type;
		} else {
			this.showacceptButton = true;
		}
	}

	ngAfterViewInit(): void {
		//cuando no tenga scroll los terminos y condiciones
		setTimeout(() => {
			const element = document.getElementById("scroll");
			if (element.offsetHeight >= element.scrollHeight) {
				this.endScroll = true;
			}
		});
	}

	closeDialog(): void {
		this.dialogo.close(false);
	}
	confirm(): void {
		this.dialogo.close(true);
	}

	onScroll() {//detecta cuando ha llegado al final del scroll
		const element = document.getElementById("scroll");
		if (element.offsetHeight + element.scrollTop >= element.scrollHeight) {
			this.endScroll = true
		}
	}


}
